import { themeGet } from '@styled-system/theme-get'
import styled from 'styled-components'
import { color, ColorProps, layout, LayoutProps, space, SpaceProps } from 'styled-system'

interface IconButtonProps extends ColorProps, LayoutProps, SpaceProps {
  disabled?: boolean
}

export const IconButton = styled.button<IconButtonProps>`
  background-color: transparent;
  border: 0;
  cursor: pointer;
  border-radius: 25px;
  width: 35px;
  height: 35px;
  min-width: 35px;
  color: ${themeGet('colors.text')};
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    ${({ disabled }) => !disabled && `background-color: rgb(0 0 0 / 15%)`};
  }

  &:active {
    transform: translateY(0.5px);
  }

  ${color};
  ${layout};
  ${space};

  ${({ disabled }) =>
    disabled &&
    `
      color: #9c9191;
      cursor: default;
    `}
`
